import AlertIcon from './AlertIcon';
import ChevronIcon from './ChevronIcon';
import ClosedEyeIcon from './ClosedEyeIcon';
import CrossIcon from './CrossIcon';
import EditIcon from './EditIcon';
import OpenEyeIcon from './OpenEyeIcon';
const Icons = Object.freeze({
  closedEye: ClosedEyeIcon,
  cross: CrossIcon,
  edit: EditIcon,
  openEye: OpenEyeIcon,
  alert: AlertIcon,
  chevron: ChevronIcon
});
export { Icons };